import React, { useState } from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { store } from "./features/Store";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-vertical-timeline-component/style.min.css";
import "./custom.scss";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
